import { IOnInit } from "angular";

export class ContractInstanceFieldsComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  $onInit(): void {}
}
